export const APP_NAME = "Michael C Streamline";
export const APP_STORE_URL = "https://apps.apple.com/app/id6786753836";
export const CONTACT_EMAIL = "support@michaelcstreamline.com";
